import { applyMiddleware, createStore } from 'redux';
import benefitApi from 'middleware/api';
import intakeApi from 'middleware/intakeApi';
import intakeV2Api from 'middleware/intakeV2Api';
import rootReducer from 'index.reducer';
import thunk from 'redux-thunk';

const configureStore = (preloadedState) =>
  createStore(rootReducer, preloadedState, applyMiddleware(thunk, intakeApi, intakeV2Api, benefitApi));

export default configureStore;
